import { TeamLayout } from '@/layouts/TeamLayout';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { HomePage } from '@/pages/home';
import { AgentsPage } from '@/pages/team/agents';
import { AgentDetailPage } from '@/pages/team/agents/[agentId]';
import { AgentExecutionDetailPage } from '@/pages/team/agents/[agentId]/executions/[executionId]';
import { AgentWorkbenchPage } from '@/pages/team/agents/[agentId]/workbench';
import { ApiTokensPage } from '@/pages/team/api-tokens';
import AuditLogsPage from '@/pages/team/audit-logs';
import { DatasetsPage } from '@/pages/team/datasets';
import { DatasetDetailPage } from '@/pages/team/datasets/[datasetId]';
import { SchemaConfigurationPage } from '@/pages/team/datasets/[datasetId]/schema';
import { FilesPage } from '@/pages/team/files';
import { FileDetailPage } from '@/pages/team/files/[fileId]';
import { TeamMembersPage } from '@/pages/team/members';
import { PipelinesPage } from '@/pages/team/pipelines';
import { PipelineDetailPage } from '@/pages/team/pipelines/[pipelineId]';
import { PipelineExecutionDetailPage } from '@/pages/team/pipelines/[pipelineId]/executions/[pipelineExecutionId]';
import { PipelineWorkbenchV2Page } from '@/pages/team/pipelines/[pipelineId]/workbench';
import { TeamSettingsPage } from '@/pages/team/settings';
import { type RouteObject } from 'react-router-dom';

export const teamRoutes: RouteObject = {
  path: 'team/:teamId',
  element: <TeamLayout />,
  children: [
    {
      index: true,
      element: <HomePage />,
    },
    {
      path: 'members',
      element: <TeamMembersPage />,
    },
    {
      path: 'datasets',
      element: <DatasetsPage />,
    },
    {
      path: 'datasets/:datasetId',
      element: <DatasetDetailPage />,
    },
    {
      path: 'datasets/:datasetId/schema',
      element: <SchemaConfigurationPage />,
    },
    {
      path: 'files',
      element: <FilesPage />,
    },
    {
      path: 'files/:fileId',
      element: <FileDetailPage />,
    },
    {
      path: 'agents',
      element: <AgentsPage />,
    },
    {
      path: 'agents/:agentId',
      element: <AgentDetailPage />,
    },
    {
      path: 'agents/:agentId/workbench',
      element: <AgentWorkbenchPage />,
    },
    {
      path: 'agents/:agentId/executions/:executionId',
      element: <AgentExecutionDetailPage />,
    },
    {
      path: 'pipelines',
      element: <PipelinesPage />,
    },
    {
      path: 'pipelines/:pipelineId',
      element: <PipelineDetailPage />,
    },
    {
      path: 'pipelines/:pipelineId/workbench',
      element: <PipelineWorkbenchV2Page />,
    },
    {
      path: 'pipelines/:pipelineId/executions/:pipelineExecutionId',
      element: <PipelineExecutionDetailPage />,
    },
    {
      path: 'audit-logs',
      element: <AuditLogsPage />,
    },
    {
      path: 'api-tokens',
      element: <ApiTokensPage />,
    },
    {
      path: 'settings',
      element: <TeamSettingsPage />,
    },
    // Team 404 catch-all
    {
      path: '*',
      element: <NotFoundPage />,
    },
  ],
};
